import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, Header, Form } from "semantic-ui-react";
import CustomTextArea from "./CustomTextArea";

const propTypes = {
  headerText: PropTypes.string,
  content: PropTypes.string,
  color: PropTypes.string,
  onSave: PropTypes.func,
  itemID: PropTypes.string,
  icon: PropTypes.string,
  buttonText: PropTypes.string,
  circular: PropTypes.bool
};

const defaultProps = {
  color: "black",
  content: null,
  itemID: "",
  icon: "home",
  buttonText: null,
  circular: true
};

class ModalComentarios extends React.Component {
  state = {
    showModal: false,
    content: this.props.content
  };

  handleShow = () => this.setState({ showModal: true });
  handleClose = () => this.setState({ showModal: false });
  handleSave = () => {
    this.setState({ showModal: false });
    this.props.onSave({
      id: this.props.itemID,
      datos: this.state.content
    });
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({ content: nextProps.content });
  }

  handleChange = ({ value }) => this.setState({ content: value });

  render() {
    return (
      <Modal
        open={this.state.showModal}
        size="small"
        trigger={
          <Button
            basic
            disabled={this.props.disabled || false}
            color={this.props.color}
            circular={this.props.circular}
            icon={this.props.icon}
            onClick={this.handleShow}
            content={this.props.buttonText}
          />
        }
        closeOnDimmerClick={false}
      >
        <Header icon={this.props.icon} content={this.props.headerText} />
        <Modal.Content>
          <Form>
            <CustomTextArea
              value={this.state.content}
              onChange={this.handleChange}
              label="Comentario"
              placeholder="Añade un comentario"
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="red"
            inverted
            icon="remove"
            content="Cerrar"
            onClick={this.handleClose}
          />

          <Button
            color="green"
            inverted
            icon="checkmark"
            content="Guardar"
            onClick={this.handleSave}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

ModalComentarios.defaultProps = defaultProps;

ModalComentarios.propTypes = propTypes;

export default ModalComentarios;



// WEBPACK FOOTER //
// ./src/pages/shared/ModalComentarios.jsx